<!--/*ng2 - this file relies on parent.parent models on lines 8-20 and
   parents validators for reactive forms on lines 42
   orignal code has been left and commented for refrence*-->

  <div
    [formGroup]="formGroupInput"
    [ngSwitch]="isMobile && isMobileConvertible"
  >
    <!-- GBDS DROPDOWN-->

    <div class="gb-dropdown" [ngClass]="{'gb-option-selected': formGroupInput.get(formControlNameInput)?.value, 'form-error': hasError}">
      <div class="gb-select-container">
        <label *ngIf="label" [for]="id" [translate]="label" style="z-index:1;"></label>
        <select
          *ngSwitchDefault
          (blur)="showError()"
          [formControlName]="formControlNameInput"
          [attr.aria-haspopup]="ariaHasPopup"
          [attr.aria-label]="ariaLabel"
          data-custom-track="customTrackValue"
          tabindex="{{tabIndex}}"
          [oxValidateHelper]="validationType"
          [id]="id"
          [name]="inputName"
        >
          <option
            *ngFor="let option of getOptions()"
            [ngValue]="option">
            {{option}}
          </option>
        </select>
      </div>
      <ul *ngSwitchCase="true" class="radio-list">
        <!-- removed | filter: filter from the li below-->
        <li *ngFor="let item of lov">
          <div class="gb-retail-label">
            <span class="gb-radio">
              <input
                [attr.aria-label]="inputName"
                [name]="inputName"
                [tabindex]="tabIndex"
                [disabled]="disabled"
                value="getCode(item)"
                type="radio"
              />
              <span aria-hidden="true" class="radio-value"></span>
            </span>
            {{
            optionsTranslate === 'false' ? getLabel(item) : (getLabel(item) | translate)
            }}
          </div>
        </li>
      </ul>
      <div *ngIf="hasError" class="gb-helper-text pt-2">
        <div class="mb-3">
          <div *ngIf="!this.formGroupInput.controls[this.formControlNameInput].errors?.['required'] || this.formGroupInput.controls[this.formControlNameInput].errors?.['invalid']">
            <span
              aria-atomic="true"
              role="alert"
              [translate]="'error_invalid'"
            ></span>
          </div>
          <div *ngIf="this.formGroupInput.controls[this.formControlNameInput].errors?.['required']">
            <span
              aria-atomic="true"
              role="alert"
              [translate]="'error_required'"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>